import Vue from 'vue';
import Vuex from 'vuex';
import {isEmpty} from 'lodash-es';

import moduleContestant from './contestantPage'; // participant / contestant page
import moduleRegistration from './registrationPage'; // register page
import moduleParticipants from './participantsList'; // register page

import utilities from '@/Utilities/common';

Vue.use(Vuex);

export const store = new Vuex.Store({
    strict: true,
    state: {
        // general content
        isLogged: false,
        kStrings: null,
        isDesktop: true,
        loading: false,
        urls: null,
        // main ws data
        contestId: null,
        activePage: null,
        pastimeInfo: null,
        customerRegistrationInfo: null,
        pastimeDescriptionContent: null,
        banner: null,
        faqs: null,
        rules: null,
        prizes: null,
        rankingBlock: null,
        recentBlock: null,
        ongoingBlocks: null, // the rest of the current active contests (blocks)
        pastimesBlocks: null, // all pastimes blocks
        bannerBlocks: null, // all pastimes blocks
        // modal data -> module ?
        modalStatus: false,
        modalData: null,
        validPhone: false,
        registerValidation: {
            canRegister: false,
            alreadyRegistered: false,
            phoneValidation: false,
            motive: null
        },
    },
    mutations: {
        // general content
        isLogged(state, payload) {
            state.isLogged = payload;
        },
        kStrings(state, payload) {
            state.kStrings = Object.assign({}, state.kStrings, payload);
        },
        loading(state, payload) {
            state.loading = payload;
        },
        isDesktop(state, payload) {
            state.isDesktop = payload;
        },
        urls(state, payload) {
            state.urls = Object.assign({}, state.urls, payload);
        },
        // main ws data
        activePage(state, payload) {
            state.activePage = payload;
        },
        contestId(state, payload) {
            state.contestId = payload;
        },
        pastimeInfo(state, payload) {
            state.pastimeInfo = Object.assign({}, state.pastimeInfo, payload);
        },
        customerRegistrationInfo(state, payload) {
            state.customerRegistrationInfo = Object.assign({}, state.customerRegistrationInfo, payload);
        },
        pastimeDescriptionContent(state, payload) {
            state.pastimeDescriptionContent = payload;
        }, 
        banner(state, payload) {
            state.banner = payload;
        },
        faqs(state, payload) {
            state.faqs = payload;
        },
        rules(state, payload) {
            state.rules = payload;
        },
        prizes(state, payload) {
            state.prizes = Object.assign({}, state.prizes, payload);
        },
        pagination(state, payload) {
            state.pagination = payload;
        },
        rankingBlock(state, payload) {
            if(payload && !isEmpty(payload)) {
                state.rankingBlock = {
                    config: [payload],
                    url: state.urls.siteBlock
                }
                
            }
            //state.rankingBlock = payload;
        },
        recentBlock(state, payload) {
            if(payload && !isEmpty(payload)) {
                state.recentBlock = {
                    config: [payload],
                    url: state.urls.siteBlock
                }

            }
        },
        ongoingBlocks(state, payload) {
            if(payload && !isEmpty(payload)) {
                state.ongoingBlocks = {
                    config: [!isEmpty(payload.blocksData) ? payload.blocksData : payload],
                    url: payload.url ? payload.url : state.urls.siteBlock
                }
            }
            /*if(payload && !isEmpty(payload)) {
                state.ongoingBlocks = {
                    config: [payload],
                    url: state.urls.siteBlock
                }
            }*/
        },
        pastimesBlocks(state, payload) {
            if(payload && !isEmpty(payload)) {
                state.pastimesBlocks = {
                    config: [payload.blocksData],
                    url: payload.url
                }
            }
        },
        bannerBlocks(state, payload) {
            if(payload && !isEmpty(payload)) {
                state.bannerBlocks = {
                    config: [payload],
                    url: state.urls.siteBlock
                }
            }
        },
        // modal data 
        modalStatus(state, payload) {
            state.modalStatus = payload;
        },
        modalData(state, payload) {
            state.modalData = payload;
        },
        validPhone(state, payload) {
            state.validPhone = payload;
        },
        registerValidation(state, payload) {
            state.registerValidation = payload;
        },
    },
    actions: {
        setWsData(context, payload) {
            if(!isEmpty(payload)) {

                let wsData = payload.wsData;
                // general data
                context.commit('isLogged', payload.isLogged);
                context.commit('kStrings', payload.kStrings);
                context.commit('isDesktop', payload.isDesktop);
                context.dispatch('setUrls', payload.baseUrls);

                // main data
                context.commit('activePage', wsData.activePage);
                context.commit('pastimeInfo', wsData.pastimeInfo);

                let enableRegistration = wsData.pastimeInfo?.detailedInfo?.enableRegistration ?? null;
                if(enableRegistration){
                    context.dispatch('setRegisterValidation', enableRegistration);
                }
                context.commit('pastimeInfo', wsData.pastimeInfo);
                context.commit('customerRegistrationInfo', wsData.customerRegistrationInfo);
                context.commit('contestId', wsData.pastimeInfo.baseInfo.id);
                context.commit('pastimeDescriptionContent', wsData.macwinContent.pastimeDescriptionContent);
                context.commit('banner', wsData.macwinContent.bannerContent);
                context.commit('faqs', wsData.pastimeInfo.detailedInfo.faqsContent);
                context.commit('rules', wsData.macwinContent.rulesContent);
                if(wsData.activePage == 'registration') {
                    context.dispatch('registrationPage/setCustomerInfo', wsData.customerInfo);
                    context.dispatch('registrationPage/setCountryOptions', wsData.pastimeInfo.countries);
                }
                
                if(!isEmpty(wsData.registrations)) {
                    context.dispatch('participantsList/setData', wsData.registrations);
                }
                if(wsData.blocks){
                    if(!isEmpty(wsData.blocks.ranking)) {
                        context.commit('rankingBlock', wsData.blocks.ranking);
                    }
    
                    if(!isEmpty(wsData.blocks.recent)) {
                        context.commit('recentBlock', wsData.blocks.recent);
                    }
                    
                    if(!isEmpty(wsData.blocks.ongoing)) {
                        context.commit('ongoingBlocks', wsData.blocks.ongoing);
                    }
                    
                    if(!isEmpty(wsData.blocks.bannerBlocks)) {
                        context.commit('bannerBlocks', wsData.blocks.bannerBlocks);
                    }
                }
            }
        },
        setPastimesListPage(context, payload) {
            context.commit('isLogged', payload.isLogged);
            context.commit('kStrings', payload.kStrings);
            context.commit('isDesktop', payload.isDesktop);
            
            // main data
            context.commit('activePage','pastimes-page');
            let blocksPayload = {
                url: payload.siteBlockUrl,
                blocksData: payload.blocksData 
            }
            context.commit('pastimesBlocks', blocksPayload);
        },
        setKStrings(context, payload) {
            context.commit('kStrings', payload);
        },
        setIsLogged(context, payload) {
            context.commit('isLogged', payload);
        },
        setIsDesktop(context, payload) {
            context.commit('isDesktop', payload);
        },
        setLoading(context, payload) {
            context.commit('loading', payload);
        },
        setUrls(context, payload) {
            context.commit('urls', payload);
            if(payload && 'registrations' in payload){
                context.commit('participantsList/urlAction', payload.registrations);
            }
        },
        setActivePage(context, payload) {
            context.commit('activePage', payload);
        }, 
        setContestId(context, payload) {
            context.commit('contestId', payload);
        },
        setPastimeInfo(context, payload) {
            context.commit('pastimeInfo', payload);
        }, 
        setCustomerRegistrationInfo(context, payload) {
            context.commit('customerRegistrationInfo', payload);
        },
        setPastimeDescriptionContent(context, payload) {
            context.commit('pastimeDescriptionContent', payload);
        },
        setBanner(context, payload) {
            context.commit('banner', payload);
        },
        setFaqs(context, payload) {
            context.commit('faqs', payload);
        },
        setRules(context, payload) {
            context.commit('rules', payload);
        },
        setPagination(context, payload) {
            context.commit('pagination', payload);
        },
        setRankingBlock(context, payload) {
            context.commit('rankingBlock', payload);
        },
        setRecentBlock(context, payload) {
            context.commit('recentBlock', payload);
        },
        setOngoingBlocks(context, payload) {
            context.commit('ongoingBlocks', payload);
        },
        setPastimesBlocks(context, payload) {
            context.commit('pastimesBlocks', payload);
        },
        setBannerBlocks(context, payload) {
            context.commit('bannerBlocks', payload);
        },
        setModalStatus(context, payload) {
            let data = null;
            if(!payload.status || !payload.context) {
                context.commit('modalData', null);
                utilities.enableBodyScroll();
            } else {
                utilities.disableBodyScroll();
                let modalContext = payload.context;
                let isMixType = payload.isMixType; // ex: recipeForm with catalogCart 
                switch(modalContext) {
                    // use slot for content?
                    case 'rules':
                        data = {
                            title: context.getters.kStrings.kRULES,
                            contentType: 'text', // simple text or html macwin content
                            content: context.getters.rules
                        }
                        break;
                    case 'faqs':
                        data = {
                            title: context.getters.kStrings.kFAQS,
                            contentType: 'accordion',
                            content: '',
                        }
                        break;
                    case 'textBodyDescription':
                        data = {
                            title: context.getters.kStrings.kSUBMISSION_DESCRIPTION,
                            contentType: 'textBodyDescription',
                            content: moduleContestant.state.registrationInfo.textBody ? moduleContestant.state.registrationInfo.textBody: '',
                        }
                        break;
                    case 'recipeDescription':
                        data = {
                            title: moduleContestant.state.registrationInfo.recipeDetails.recipeInfo.recipeName,
                            contentType: 'recipeDescription',
                            content: moduleContestant.state.registrationInfo.recipeDetails,
                        }
                        break;     
                    case 'imageEdit':
                        let hasFile = payload.hasOwnProperty('file') && !isEmpty(payload.file);
                        data = {
                            title: context.getters.kStrings.kFRAME_YOUR_PHOTO,
                            contentType: 'imageEdit',
                            content: hasFile ? payload.file : null,
                        }
                        break;
                        // pastime type user/event
                    case 'descriptionForm':
                        // saved defaults for edit modal
                        let defaultTitle = moduleRegistration.state.descriptionForm.hasOwnProperty('title') ? moduleRegistration.state.descriptionForm.title : '';
                        let defaultBody = moduleRegistration.state.descriptionForm.hasOwnProperty('description') ? moduleRegistration.state.descriptionForm.description : '';
                        
                        data = {
                            title: context.getters.kStrings.kINFO_SLASH_PRODUCTS,
                            contentType: 'descriptionForm',
                            content: {
                                inputs: {
                                    title: {
                                        type: 'text',
                                        label: context.getters.kStrings.kPARTICIPATION_TITLE + ':',
                                        defaultValue: defaultTitle
                                    },
                                    body: {
                                        type: 'textarea',
                                        label: context.getters.kStrings.kSAY_SOMETHING_ABOUT_PROZIS_PRODUCTS + ':',
                                        defaultValue: defaultBody
                                    }
                                },
                                buttons: {
                                    submit: {
                                        url: context.getters.urls.home,
                                        label: context.getters.kStrings.kGLOB_SUBMIT,
                                    },
                                }
                            },
                        }
                        break;
                        // pastime type recipe / instructions
                    case 'recipeForm':
                        // saved defaults for edit modal
                        let defaultName = moduleRegistration.state.recipeForm.hasOwnProperty('name') ? moduleRegistration.state.recipeForm.name : '';
                        let defaultPrepTime = moduleRegistration.state.recipeForm.hasOwnProperty('preparationTime') ? moduleRegistration.state.recipeForm.preparationTime : '';
                        let defaultCookingTime = moduleRegistration.state.recipeForm.hasOwnProperty('cookingTime') ? moduleRegistration.state.recipeForm.cookingTime : '';
                        let defaultIngredientList = moduleRegistration.state.recipeForm.hasOwnProperty('ingredientList') ? moduleRegistration.state.recipeForm.ingredientList : [];
                        let defaultPreparationStepsList = moduleRegistration.state.recipeForm.hasOwnProperty('preparationStepsList') ? moduleRegistration.state.recipeForm.preparationStepsList : [];
                        let defaultObservations = moduleRegistration.state.recipeForm.hasOwnProperty('observations') ? moduleRegistration.state.recipeForm.observations : '';
                        //let defaultProductList = moduleRegistration.state.recipeForm.hasOwnProperty('productList') ? moduleRegistration.state.recipeForm.productList : '';
                        data = {
                            title: context.getters.kStrings.kRECIPE_INSTRUCTIONS_INGREDIENTS,
                            contentType: 'recipeForm',
                            isMixType: isMixType,
                            content: {
                                inputs: {
                                    name: {
                                        type: 'text',
                                        label: context.getters.kStrings.kGLOB_TITLE,
                                        defaultValue: defaultName
                                    },
                                    preparationTime: {
                                        type: 'text',
                                        label: context.getters.kStrings.kRECIPE_TIME_PREP,
                                        defaultValue: defaultPrepTime
                                    },
                                    cookingTime: {
                                        type: 'text',
                                        label: context.getters.kStrings.kRECIPE_TIME_COOKING,
                                        defaultValue: defaultCookingTime
                                    },
                                    ingredientList: defaultIngredientList,
                                    preparationStepsList: defaultPreparationStepsList,
                                    observations: {
                                        type: 'textarea',
                                        label: context.getters.kStrings.kOBSERVATIONS + ':',
                                        defaultValue: defaultObservations
                                    },
                                    //productList: defaultProductList
                                },
                                buttons: {
                                    submit: {
                                        url: context.getters.urls.home,
                                        label: context.getters.kStrings.kGLOB_SUBMIT,
                                    },
                                }
                            },
                        }
                        break;
                    case 'smsValidation':
                        data = {
                            title: context.getters.kStrings.kPHONE_VALIDATION,
                            contentType: 'smsValidation',
                            content: {
                                inputs: {
                                    phoneValidation: {
                                        type: 'tel',
                                        label: context.getters.kStrings.kPHONE_NUMBER,
                                    },  
                                },
                                buttons: {
                                    submitPhoneNumber: {
                                        url: context.getters.urls.submitPhoneNumber,
                                        label: context.getters.kStrings.kVALIDATE_PHONE,
                                    },
                                }
                            },
                        }
                        break;
                    case 'catalogCart':
                        data = {
                            title: context.getters.kStrings.kGLOB_ADD_PRODUCTS,
                            contentType: 'catalogCart', // simple text or html macwin content
                            content: '',
                            isMixType: isMixType,
                        }
                        break;
                    default:
                        break;
                }
            
            }
            context.commit('modalData', data);
            context.commit('modalStatus', payload.status);
            
        },
        setModalData(context, payload) {
            /* 
                ex: {
                    context: 'rules',
                    title: 'Rules',
                    contentType: 'text',
                    content: 'biscoitos'
                }
            */
            context.commit('modalData', payload);
        },
        setValidPhone(context, payload) {
            context.commit('validPhone', payload);
        },
        setRegisterValidation(context, payload) {
            let data = {
                canRegister: payload?.canRegister ?? false,
                alreadyRegistered: payload?.alreadyRegistered ?? false,
                phoneValidation: payload?.phoneValidation ?? false,
                motive: payload?.motive ?? null,
            };
            context.commit('registerValidation', data);
        },
    },
    getters: {
        isLogged: state => state.isLogged,
        kStrings: state => state.kStrings,
        isDesktop: state => state.isDesktop,
        loading: state => state.loading,
        urls: state => state.urls,
        contestId: state => state.contestId,
        activePage: state => state.activePage,
        pastimeInfo: state => state.pastimeInfo,
        customerRegistrationInfo: state => state.customerRegistrationInfo,
        pastimeDescriptionContent: state => state.pastimeDescriptionContent,
        banner: state => state.banner,
        faqs: state => state.faqs,
        rules: state => state.rules,
        participants: state => state.participantsList.registrations,
        pagination: state => state.participantsList.pagination,
        rankingBlock: state => state.rankingBlock,
        recentBlock: state => state.recentBlock,
        ongoingBlocks: state => state.ongoingBlocks,
        pastimesBlocks: state => state.pastimesBlocks,
        bannerBlocks: state => state.bannerBlocks,
        modalStatus: state => state.modalStatus,
        modalData: state => state.modalData,
        validPhone: state => state.validPhone,
        registerValidation: state => state.registerValidation
    },
    modules: {
        contestantPage: moduleContestant,
        registrationPage: moduleRegistration,
        participantsList: moduleParticipants,
    }
});